import { QueryProvider } from '@/app/providers/QueryProvider';
import { router } from '@/app/router';
import { NetworkErrorDialog } from '@/shared/components/NetworkErrorDialog';
import { AppOnlyDialog } from '@/shared/components/app-guide/AppOnlyDialog';
import { Icon } from '@/shared/components/ui/icon';
import { RouterProvider } from '@tanstack/react-router';
import type { CSSProperties } from 'react';
import { Toaster } from 'sonner';

function App() {
  return (
    <QueryProvider>
      <RouterProvider router={router} />
      {/*
       * 토스트 — Figma Toast (840:4478): 폭 360 · radius 20 · 안쪽 16 · 아이콘 24 + 14 SemiBold 흰 글자 · 그림자 500
       * 위치: 상단 가운데, GNB 바로 아래 24px (GNB가 --app-header-height를 알려 준다. 로그인 등 GNB 없는 화면은 24px)
       */}
      <Toaster
        position="top-center"
        offset={{ top: 'calc(var(--app-header-height, 0px) + 24px)' }}
        mobileOffset={{ top: 'calc(var(--app-header-height, 0px) + 16px)' }}
        style={{ '--width': '360px' } as CSSProperties}
        icons={{
          success: <Icon name="check-circle-line-24" />,
          error: <Icon name="warning-circle-line-24" />,
          info: <Icon name="info-circle-line-24" />,
        }}
        toastOptions={{
          unstyled: true,
          classNames: {
            toast:
              'flex w-full items-start gap-2 rounded-20 p-4 text-fg-white shadow-500',
            // 배경은 종류별로만 준다 — 기본 클래스와 겹치면 CSS 순서에 따라 success 초록이 검정에 묻힌다
            default: 'bg-grey-900',
            info: 'bg-grey-900',
            success: 'bg-green-500',
            error: 'bg-red-500',
            icon: 'flex size-6 shrink-0 items-center justify-center',
            content: 'flex min-w-0 flex-1 flex-col',
            title: 'text-body-14-sb text-fg-white',
            description: 'text-body-13-r text-fg-white-secondary',
          },
        }}
      />
      {/* X6 앱 전용 기능 공통 팝업 */}
      <AppOnlyDialog />
      {/* X8 연결 불안정 팝업 */}
      <NetworkErrorDialog />
    </QueryProvider>
  );
}

export default App;
